import axios from "axios";

import Cookies from "universal-cookie";

function getToken() {
  const cookies = new Cookies();
  const token = cookies.get("token");

  return token;
}

export const taskList = async (page, perPage) => {
  return await axios.get(
    `${process.env.REACT_APP_API}/task/all?page=${page || 1}&perPage=${perPage || 10
    }`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

export const IndividualTask = async (id) => {
  return await axios.get(`${process.env.REACT_APP_API}/task/${id}`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });
};

export const answerTask = async (id) => {
  return await axios.get(
    `${process.env.REACT_APP_API}/answer/individual/${id}`,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

export const UpdateTask = async (id, tokenC, selectedImage) => {
  return await axios.put(
    `${process.env.REACT_APP_API}/task/update/${id}`,
    selectedImage,
    {
      headers: {
        // "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

export const searchTask = async (tranId, page, perPage) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/task/searchtask?page${page || 1}&perPage=${perPage || 10
    }`,
    { tranId: tranId },
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

export const updateAnswer = async (id, data) => {
  return await axios.put(
    `${process.env.REACT_APP_API}/answer/update/${id}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

// --- create answer (multipart) ---
export const createAnswer = async (formData) => {
  return await axios.post(`${process.env.REACT_APP_API}/answer`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getToken()}`,
    },
  });
};

// --- load job-type survey template ---
export const loadSurveyByJobType = async (jobType) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/surveyTemplate/searchSurveyTemplate`,
    { jobType },
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

